module.exports = __webpack_public_path__ + "static/media/guitar-silhouette.96ce2edb.svg";